module.exports = __webpack_public_path__ + "static/img/img_logo.98c5b0fa.png";